module.exports = __webpack_public_path__ + "media/audio31.668998d7.mp3";